import { ProjectSwiper } from "../components/ProjectSwiper";

export const Projects = ({  ref, darkMode, setDarkMode ,popup,setPopup}) => {
  return (
    <div
      ref={ref}
      id="project"
      className={`pt-16  md:pt-0 relative h-screen flex flex-col justify-center 
      px-8 sm:px-16 md:px-24 xl:px-40 2xl:px-52
      ${darkMode ? "text-white" : "text-black"}`}
    >
      <div className="flex flex-col h-2/3 w-full gap-3">
        <h1 className="font-serif text-4xl pt-4">Projects </h1>
        <p className="text-gray-500  font-serif text-base max-w-[600px] ">
          These are some highlight projects. Each page discusses the purpose of
          the project, what was learned, and how I came up with solutions.
        </p>
        <div className="pt-3">
          <ProjectSwiper
            darkMode={darkMode}
            setDarkMode={setDarkMode}
            popup={popup}
            setPopup={setPopup}
          />
        </div>
      </div>
    </div>
  );
};
